import { useSelector } from 'react-redux';

type Props = {
  onClick: () => void;
};

export default function EditPersonalization({ onClick }) {
  const pdpItem: any = useSelector<any>((state) => state.pdpItem);
  const {
    details: {
      attributes: { all: allAtributes },
    },
  } = pdpItem;

  return (
    <button
      onClick={onClick}
      className='tw:my-4 tw:flex tw:w-full tw:cursor-pointer tw:items-center tw:justify-between tw:rounded-button tw:border tw:border-neutrals-light-grey tw:bg-white tw:px-2.5 tw:py-3 tw:no-underline tw:transition tw:duration-200 tw:hover:border-neutrals-medium-grey tw:hover:!text-brand-black'>
      <div>
        <div className='tw:inline-flex tw:w-full tw:items-center tw:space-x-1.5 tw:text-sm tw:font-normal tw:text-brand-black'>
          <div>Personalized with</div>
          <img src='/assets/images/rtic/myRTIC-Logo.png' className='tw:h-[14px] tw:w-full tw:max-w-[65px]' />
        </div>
        <div className='tw:text-neutrals-brand-black tw:flex tw:space-x-2.5 tw:text-sm'>
          {allAtributes.map((attribute, index) => (
            <Attribute attribute={attribute} key={index} />
          ))}
        </div>
      </div>
      <div className='flex items-center justify-end'>
        <div className='tw:flex tw:items-center tw:space-x-1 tw:text-xs tw:font-normal'>
          <div>Edit Design</div>
          <div>
            <i className='fa fa-chevron-right text-muted' />
          </div>
        </div>
      </div>
    </button>
  );
}

const Attribute = ({ attribute }) =>
  attribute.key === 'color' ? (
    <div>
      Color <b className='tw:text-brand-black'>{attribute.value}</b>
    </div>
  ) : attribute.key === 'size' ? (
    <div>
      Size <b className='tw:text-brand-black'>{attribute.value}</b>
    </div>
  ) : null;
